(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabbed-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tabbed-gallery__tab');
  
  tabs.forEach(tab => {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      
      const selectedTab = this.dataset.tab;
      
      // Remove active class from all tabs
      tabs.forEach(btn => btn.classList.remove('active'));
      
      // Add active class to clicked tab
      this.classList.add('active');
      
      // Hide all gallery grids
      document.querySelectorAll('.tabbed-gallery__grid').forEach(grid => {
        grid.classList.add('hidden');
      });
      
      // Show selected gallery grid
      const selectedGrid = document.getElementById(selectedTab);
      if (selectedGrid) {
        selectedGrid.classList.remove('hidden');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
